<template>
    <div class="uk-padding" style="background-color: #033860; border-top: gold 2px solid">
        <div class="uk-container uk-container-expand">
            <div class="uk-child-width-expand@l  " uk-grid>
                <div  style="">
                    <br>
                    <div class="uk-text-left" style="margin-top: 5px; border-left: rgba(197,179,88, 0.2) 1px solid; padding-left: 15px">
                        <div style="" uk-grid>
                            <div class="uk-width-1-1@m">
                                <!--<h5  class="uk-text-small uk-light uk-margin-remove-bottom" style="font-variant: all-small-caps; font-size: large; color: rgb(197, 179, 88)">Contact Info</h5>
                                <br>-->
                                <label class="uk-text-small uk-light" style="font-variant: all-small-caps; font-size: medium; color: #999">Address:</label>
                                <br>
                                <label class=" uk-light" style="font-variant: all-small-caps; font-size: medium; color: gold;">
                                    Northern Caribbean University, <br>
                                    Manchester Rd.
                                    Mandeville, <br>
                                    Manchester,
                                    Jamaica
                                </label><br><br>
                                <label class="uk-text-small uk-light" style="font-variant: all-small-caps; font-size: medium; color: #999">Telephone:</label>

                                <label class="uk-text-small SecondsubHeadings uk-light" style="padding-left: 15px; color: gold"> 1-876-618-1652 </label><br>
                                <label class="uk-text-small SecondsubHeadings uk-light" style="padding-left: 15px; color: gold"> 1-876-963-7000/7400</label>
                                <br>
                                <label class="uk-text-small " style="font-variant: all-small-caps; font-size: small; color: #999">Toll:</label>
                                <label class="uk-text-small SecondsubHeadings uk-light" style="padding-left: 15px; color: gold"> 1-888-429-5628 </label><br>
                                <label class="uk-text-small uk-light" style="font-variant: all-small-caps; font-size: small; color: #999">Fax:</label>
                                <label class="uk-text-small SecondsubHeadings uk-light" style="padding-left: 15px; color: gold"> 1-876-962-0075 </label>

                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <br>
                    <div class="uk-padding-large-left uk-text-muted"  style="border-left: rgba(197,179,88, 0.2) 1px solid; padding-left: 15px">
                        <a href="https://apply.ncu.edu.jm" target="_blank" style="color: white;" class="uk-link-text SecondsubHeadings">
                            <!--<span class="uk-margin-small-right" uk-icon="icon: link;"></span>--><i>Apply</i></a><br>
                        <router-link to="/bulletins" class="uk-link-text SecondsubHeadings">
                            <!--<span class="uk-margin-small-right" uk-icon="icon: link;"></span>-->Bulletins</router-link><br>
                        <router-link to="/certificateprograms" class="uk-link-text SecondsubHeadings">
                            <!--<span class="uk-margin-small-right" uk-icon="icon: link;"></span>-->Certificate & Diplomas</router-link><br>
                        <router-link to="/onlineeducation" class="uk-link-text SecondsubHeadings">
                            <!--<span class="uk-margin-small-right" uk-icon="icon: link;"></span>-->Digital Education</router-link><br>
                        <router-link to="/donate" class="uk-link-text SecondsubHeadings">
                            <!--<span class="uk-margin-small-right" uk-icon="icon: link;"></span>-->Donate to NCU</router-link><br>
                        <router-link to="/extensionprograms" class="uk-link-text SecondsubHeadings">
                            <!--<span class="uk-margin-small-right" uk-icon="icon: link;"></span>-->Extension Campus Offerings</router-link><br>
                        <router-link to="/gradprograms" class="uk-link-text SecondsubHeadings">
                            <!--<span class="uk-margin-small-right" uk-icon="icon: link;"></span>-->Graduate Programmes</router-link><br>

                            <router-link to="/applicationforms" class="uk-link-text SecondsubHeadings">
                                <!--<span class="uk-margin-small-right" uk-icon="icon: link;"></span>-->Student Forms</router-link><br>
                        <router-link to="/undergradprograms" class="uk-link-text SecondsubHeadings">
                            <!--<span class="uk-margin-small-right" uk-icon="icon: link;"></span>-->Undergraduate Programmes</router-link><br>
                    </div>
                </div>
                <div>
                    <div class="uk-text-center">
                        <router-link  to="/">
                            <img src="../../assets/logo.png" style="padding: 10px; max-width: 400px; max-height: 400px; height: auto; width: auto;" alt="">
                        </router-link>
                        <p class=" uk-margin-remove-top uk-light" style="font-variant: all-small-caps">
                            Ubi Semper Discimus <br> Where learning never ends
                        </p>
                        <div class="icon ">
                            <!--<p class="uk-text-center">Find Us | Like Us</p>-->
                            <div >
                                <!--<span class="uk-margin-small-right" style="font-variant: all-petite-caps; color: rgb(197, 179, 88); font-size: x-large" >Northern Caribbean University </span>-->

                                <a href="https://twitter.com/ncueducation" target="_blank" class="uk-icon-button uk-margin-small-right" uk-icon="twitter" style="color: #ffcb05 !important; background-color: rgba(13, 66, 106, 0.9);"></a>

                                <a href="https://www.facebook.com/ncueducation/" target="_blank" class="uk-icon-button  uk-margin-small-right" uk-icon="facebook" style="color: #ffcb05 !important; background-color: rgba(13, 66, 106, 0.9);"></a>

                                <a href="https://plus.google.com/106251138258617752932" target="_blank" class="uk-icon-button uk-margin-small-right" uk-icon="google-plus" style="color: #ffcb05 !important; background-color: rgba(13, 66, 106, 0.9);"></a>

                                <a href="https://www.instagram.com/ncu_jamaica/" target="_blank" class="uk-icon-button uk-margin-small-right" uk-icon="instagram" style="color: #ffcb05 !important; background-color: rgba(13, 66, 106, 0.9);"></a>

                                <a href="https://www.flickr.com/photos/72113266@N04/" target="_blank" class="uk-icon-button  uk-margin-small-right" uk-icon="flickr" style="color: #ffcb05 !important; background-color: rgba(13, 66, 106, 0.9);"></a>

                                <a href="https://jm.linkedin.com/school/northern-caribbean-university/" target="_blank" class="uk-icon-button uk-margin-small-right" uk-icon="linkedin" style="color: #ffcb05 !important; background-color: rgba(13, 66, 106, 0.9);"></a>

                                <a href="https://www.youtube.com/channel/UCaAlpTlb1Qk-S-UVGKtijKg" target="_blank" class="uk-icon-button uk-margin-small-right" uk-icon="youtube" style="color: #ffcb05 !important; background-color: rgba(13, 66, 106, 0.9);"></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <br>
                    <div class=" uk-text-muted uk-align-right uk-text-right"  style="border-right: rgba(197,179,88, 0.2) 1px solid; padding-right: 15px">
                        <router-link to="/careerservices"  style="color: white;" class="uk-link-text SecondsubHeadings">
                            <!--<span class="uk-margin-small-right" uk-icon="icon: link;"></span>-->Career Services</router-link><br>
                        <router-link to="/counsellingpsychology" class="uk-link-text SecondsubHeadings">
                            <!--<span class="uk-margin-small-right" uk-icon="icon: link;"></span>-->Counselling & Psychology</router-link><br>
                        <router-link to="/fitnesscentre" class="uk-link-text SecondsubHeadings">
                            <!--<span class="uk-margin-small-right" uk-icon="icon: link;"></span>-->Fitness Centre</router-link><br>
                        <router-link to="healthwellness" class="uk-link-text SecondsubHeadings">
                            <!--<span class="uk-margin-small-right" uk-icon="icon: link;"></span>-->Health & Wellness Centre</router-link><br>
                        <a href="http://www.ncu.edu.jm/library/" target="_blank" class="uk-link-text SecondsubHeadings">
                            <!--<span class="uk-margin-small-right" uk-icon="icon: link;"></span>-->Hiram S. Walters Resource Centre</a><br>
                        <router-link to="/internationalstudents" class="uk-link-text SecondsubHeadings">
                            <!--<span class="uk-margin-small-right" uk-icon="icon: link;"></span>-->International Student Services</router-link><br>
                        <router-link to="/studentfinance" class="uk-link-text SecondsubHeadings">
                            <!--<span class="uk-margin-small-right" uk-icon="icon: link;"></span>-->Student Finance</router-link><br>
                        <router-link to="/scholarshipandstudentaid" class="uk-link-text SecondsubHeadings">
                            <!--<span class="uk-margin-small-right" uk-icon="icon: link;"></span>-->Scholarships and Student Aid</router-link><br>
                        <router-link to="/records" target="_blank" class="uk-link-text SecondsubHeadings">
                            <!--<span class="uk-margin-small-right" uk-icon="icon: link;"></span>-->University Records</router-link><br>

                    </div>
                </div>
                <div>

                    <div >

                        <br>
                        <div class=" uk-text-muted uk-align-right uk-text-right" style="border-right: rgba(197,179,88, 0.2) 1px solid; padding-right: 15px">
                            <router-link to="/alumni"  class="uk-link-text SecondsubHeadings">
                                <!--<span class="uk-margin-small-right" uk-icon="icon: link;"></span>-->Alumni</router-link><br>
                            <router-link to="/academiccalendar" class="uk-link-text SecondsubHeadings">
                                <!--<span class="uk-margin-small-right" uk-icon="icon: link;"></span>-->Academic Calendar</router-link><br>
                            <a href="https://aeorion.ncu.edu.jm/" target="_blank" style="color: white;" class="uk-link-text SecondsubHeadings">
                                <!--<span class="uk-margin-small-right" uk-icon="icon: link;"></span>-->Aeorion LMS</a><br>
                            <router-link to="/eventscalendar" class="uk-link-text SecondsubHeadings">
                                <!--<span class="uk-margin-small-right" uk-icon="icon: link;"></span>-->Events Calendar</router-link><br>
                            <router-link to="/uniss"  class="uk-link-text SecondsubHeadings">
                                <!--<span class="uk-margin-small-right" uk-icon="icon: link;"></span>-->UNISS</router-link><br>

                            <!--<a target="_blank" href="https://accounts.google.com/signin/v2/identifier?service=mail&passive=true&rm=false&continue=https%3A%2F%2Fmail.google.com%2Fmail%2F&ss=1&scc=1&ltmpl=default&ltmplcache=2&emr=1&osid=1&flowName=GlifWebSignIn&flowEntry=ServiceLogin" class="uk-link-text SecondsubHeadings">
                                &lt;!&ndash;<span class="uk-margin-small-right" uk-icon="icon: link;"></span>&ndash;&gt;Student Gmail</a><br>-->
                            <a href="/Student_Guide.pdf" target="_blank" class="uk-link-text SecondsubHeadings">
                                <!--<span class="uk-margin-small-right" uk-icon="icon: link;"></span>-->Student Handbook</a><br>
                            <router-link to="/openinghours" class="uk-link-text SecondsubHeadings">
                                <!--<span class="uk-margin-small-right" uk-icon="icon: link;"></span>-->Campus Opening Hours</router-link><br>
                            <a target="_blank" href="https://transcripts.ncu.edu.jm" class="uk-link-text SecondsubHeadings">
                                <!--<span class="uk-margin-small-right" uk-icon="icon: link;"></span>-->Transcript Requests</a><br>
                          <router-link to="/privacy" class="uk-link-text SecondsubHeadings">
                           Privacy</router-link><br>
                          <router-link to="/dataProtection" class="uk-link-text SecondsubHeadings">
                           Data Protection</router-link><br>
                        </div>
                    </div>
                </div>
            </div>

            <hr>


        </div>

    </div>
</template>

<script>
    export default {
        name: "foot"
    }
</script>

<style scoped>
.SecondsubHeadings{
    font-size: small !important;
}


@media screen and (max-width:600px){


    /*.icon a{*/
    /*    font-size: 50px;*/
    /*}*/


}
    a{
        color: #c0c0c0 !important;
    }
    img{
        width: 150px !important;
        height: 150px !important;
    }

</style>
